import { Trans, useTranslation } from 'react-i18next';

import { PersonReadModel, useDeletePersonsByIdMutation } from '@client/api';
import { Button, Modal, ModalFooter } from '@client/toolkit';
import { DeleteConfirmationModalContent } from '../../../../components/delete-confirmation-modal-content/delete-confirmation-modal-content';

interface UserDeleteModalProps {
  user: PersonReadModel | null;
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

export function UserDeleteModal({ user, open, onCancel, onDelete }: UserDeleteModalProps) {
  const { t: tCommon } = useTranslation();

  const [deletePerson, { isLoading: isDeletingPerson }] = useDeletePersonsByIdMutation();

  const handleDeleteUser = async () => {
    if (user?.id == null) return;
    await deletePerson({ id: user.id });
    onDelete();
  };

  const handleClose = () => {
    if (isDeletingPerson) return;
    onCancel();
  };

  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose} closeDisabled={isDeletingPerson}>
      <DeleteConfirmationModalContent name={user?.name ?? ''} />
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleDeleteUser} progressing={isDeletingPerson}>
          {tCommon('delete')}
        </Button>
        <Button color="primary-dark" onClick={handleClose}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
